export default {
  namespaced: true,
  state: {
    countHousesOnPage: 10
  },
  mutations: {
    setCountHousesOnPage(state, payload) {
      if (payload > 20) {
        payload = 20
      }
      state.countHousesOnPage = payload
    }
  }

}
